import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from './en'
import zhLocale from './zh'

Vue.use(VueI18n)

let lang = localStorage.getItem('i18_lang')
if (!lang) {
  lang = 'zh' // 防止页面刷新
}
const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale // 将enLocale和elementEnLocale两个JSON格式的内容合并成一个JSON格式的内容
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale // 将zhLocal和elementZhLocale两个JSON格式的内容合并成一个JSON格式的内容
  }
}
locale.i18n((key, value) => i18n.t(key, value))
const i18n = new VueI18n({
  locale: lang, // 语言
  messages
})
export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js